
interface Props {
  onClick?: () => void;
  className?: string;
}

export default function IconE(props: Props) {
  const { onClick, className } = props;

  return (
    <div 
      onClick={onClick}
      className={className}
    >
      <span>E</span>
    </div>
  );
}